import React from "react";
import Icon from "@ant-design/icons";

const IconLock = ({ isLock, onClickLock, hidden }) => {
  return (
    <Icon
      component={isLock ? LockSvg : UnLockSvg}
      onClick={onClickLock}
      style={{ visibility: hidden ? "hidden" : "" }}
    />
  );
};

export default IconLock;

const LockSvg = () => (
  <svg width="12" height="15" viewBox="0 0 12 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.0001 5.33329H9.33341V3.99996C9.33341 2.15996 7.84008 0.666626 6.00008 0.666626C4.16008 0.666626 2.66675 2.15996 2.66675 3.99996V5.33329H2.00008C1.26675 5.33329 0.666748 5.93329 0.666748 6.66663V13.3333C0.666748 14.0666 1.26675 14.6666 2.00008 14.6666H10.0001C10.7334 14.6666 11.3334 14.0666 11.3334 13.3333V6.66663C11.3334 5.93329 10.7334 5.33329 10.0001 5.33329ZM6.00008 11.3333C5.26675 11.3333 4.66675 10.7333 4.66675 9.99996C4.66675 9.26663 5.26675 8.66663 6.00008 8.66663C6.73341 8.66663 7.33341 9.26663 7.33341 9.99996C7.33341 10.7333 6.73341 11.3333 6.00008 11.3333ZM8.06675 5.33329H3.93341V3.99996C3.93341 2.85996 4.86008 1.93329 6.00008 1.93329C7.14008 1.93329 8.06675 2.85996 8.06675 3.99996V5.33329Z"
      fill="var(--primary-color)"
    />
  </svg>
);

const UnLockSvg = () => (
  <svg width="12" height="15" viewBox="0 0 12 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.0001 5.33329H9.33341V3.99996C9.33341 2.15996 7.84008 0.666626 6.00008 0.666626C4.16008 0.666626 2.66675 2.15996 2.66675 3.99996H4.00008C4.00008 2.89329 4.89341 1.99996 6.00008 1.99996C7.10675 1.99996 8.00008 2.89329 8.00008 3.99996V5.33329H2.00008C1.26675 5.33329 0.666748 5.93329 0.666748 6.66663V13.3333C0.666748 14.0666 1.26675 14.6666 2.00008 14.6666H10.0001C10.7334 14.6666 11.3334 14.0666 11.3334 13.3333V6.66663C11.3334 5.93329 10.7334 5.33329 10.0001 5.33329ZM10.0001 13.3333H2.00008V6.66663H10.0001V13.3333ZM6.00008 11.3333C6.73341 11.3333 7.33341 10.7333 7.33341 9.99996C7.33341 9.26663 6.73341 8.66663 6.00008 8.66663C5.26675 8.66663 4.66675 9.26663 4.66675 9.99996C4.66675 10.7333 5.26675 11.3333 6.00008 11.3333Z"
      fill="#E0E0E0"
    />
  </svg>
);
